module.exports = __webpack_public_path__ + "ao.svg?d70bb5e74e51cafa0d71ca24aef069d4";